import { motion, useScroll, useSpring } from "framer-motion";

/** Dünner Lesefortschritts-Balken am oberen Rand. */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 26,
    restDelta: 0.001,
  });

  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress"
      style={{ scaleX }}
      className="scroll-progress fixed top-0 inset-x-0 z-[70] h-[3px] pointer-events-none"
    />
  );
}
